import React from 'react';
import { ColumnsType } from 'antd/es/table';

import { getTableSortOrder } from '../../common/getTableSortOrder';
import { LinkTableCell } from '../../components/LinkTableCell';
import { PageRoutesEnum } from '../../utils/routes';

import { ClientsDataType } from './useClientsTableDataSource';

export const useClientsTableColumnDefinitions = ({
  sortedInfo,
}: {
  sortedInfo: { field: string; order: string }[];
}): ColumnsType<ClientsDataType> => [
  {
    title: 'Client name',
    dataIndex: 'name',
    render: (text: string, record: ClientsDataType) => (
      <LinkTableCell text={text} record={record} pageRoute={PageRoutesEnum.clientEdit} />
    ),
    sorter: {
      compare: () => 0,
      multiple: 1,
    },
    sortOrder: getTableSortOrder(sortedInfo, 'name'),
  },
];
